import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    accountType: Yup.string(),
    accountStatus: Yup.string(),
});